import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, keywords, image, url, schema }) {
  const siteTitle = "Nily | The Mental Health OS";
  const defaultDescription = "One intelligent operating system for mental wellbeing. Unifying B2C daily care, B2B workplace analytics, and clinical diagnostics.";
  const defaultImage = "https://nily.me/assets/og-preview.jpg";
  const siteUrl = "https://nily.me";

  const fullTitle = title ? `${title} | Nily` : siteTitle;

  return (
    <Helmet>
      {/* Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || "mental health OS, corporate wellbeing, AI therapy, clinical diagnostics"} />
      <link rel="canonical" href={url || siteUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url || siteUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={image || defaultImage} />

      {/* JSON-LD Schema for AI */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
